import { render, staticRenderFns } from "./LogoutBtn.vue?vue&type=template&id=0313372a&scoped=true&"
import script from "./LogoutBtn.vue?vue&type=script&lang=js&"
export * from "./LogoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./LogoutBtn.vue?vue&type=style&index=0&id=0313372a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313372a",
  null
  
)

export default component.exports